import styled from 'styled-components';

import { iconButton } from '../../styles/mixins';

const Container = styled.button`
  ${iconButton}
  height: 3.8rem;
`;

export default Container;
